import SelectCompanyFromList from "company/selectFromList/app";
import { Modal } from "components";
import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import { useOpenNewCompanySidePanel } from "components/SidePanel/Company/NewCompanySidePanel";
import React from "react";

interface Props {
  onClose: () => void
  onCompanyLinked: (companyId: number) => void
  contactId: number
  excludeKeys: number[]
}

const NewCompanyModal = (props: Props) => {
  const openNewCompanySidePanel = useOpenNewCompanySidePanel();
  const [displaySelectCompanyModal, setDisplaySelectCompanyModal] = React.useState(false);

  const onLinkClicked = () => {
    setDisplaySelectCompanyModal(true);
  };

  const onCompanySelected = async (c: server.dto.CompanySmall) => {
    props.onCompanyLinked(c.companyId);
  };

  return <>
    <Modal
      title={""}
      style={{ width: 350 }}
      displayHeader={false}
      isOpen
      gap="regular"
      handleClose={props.onClose}
    >
      <ButtonPrimary
        onClick={() => openNewCompanySidePanel({ type: "company", onCreated: (c) => props.onCompanyLinked(c.companyId), afterCreate: "closeSidebar" })}
        label={RESX.Company.NewCompany}
      />

      <ButtonSecondary
        onClick={onLinkClicked}
        label={RESX.Company.LinkExistingCompany}
      />
    </Modal >

    <Modal
      title={RESX.Company.LinkExistingCompany}
      isOpen={displaySelectCompanyModal}
      handleClose={() => { setDisplaySelectCompanyModal(false); }}
      width="small"
      height={700}
    >
      <SelectCompanyFromList
        onCompanySelected={onCompanySelected}
        initialInstruction={{
          excludeKeys: props.excludeKeys
        }}
      />
    </Modal>
  </>;
};

export default NewCompanyModal;